import React from 'react';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import Eyebrow from '../atoms/text/Eyebrow';
import DescriptionText from '../atoms/text/DescriptionText';
import LinkButton from '../atoms/LinkButton';
import Footnote from '../atoms/text/Footnote';

const Style = styled.div`
  ${props => {
    const {
      theme: { media = {} },
      imgSrc
    } = props;
    return css`
      height: 488px;
      position: relative;
      background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
        url(${imgSrc?.mobile ||
          imgSrc?.desktop ||
          'https://images.fastcompany.net/image/upload/v1485990651/fcweb/fastcompanyimagedefault.jpg'});
      background-size: cover;
      background-position: center;

      ${media.sm.up} {
        height: 387px;
        background: linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)),
          url(${imgSrc?.desktop ||
            'https://images.fastcompany.net/image/upload/v1485990651/fcweb/fastcompanyimagedefault.jpg'});
        background-size: cover;
        background-position: center;
      }

      ${media.md.up} {
        height: 697px;
      }

      .img-container {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;

        img {
          display: block;
          height: 100%;
          width: 100%;
          object-fit: cover;
          object-position: center;
          filter: brightness(0.5);
        }
      }

      .text-container {
        position: absolute;
        z-index: 1;
        left: 0;
        bottom: 0;
        margin: 0 30px 30px 30px;
        max-width: 450px;

        ${media.sm.up} {
          margin: 0 20px 20px 20px;
        }

        ${media.md.up} {
          max-width: 650px;
          margin: 0 50px 50px 50px;
        }

        .eyebrow,
        .title,
        .text {
          color: white;
          padding-bottom: 6px;
        }

        .badge {
          padding-bottom: 6px;
        }

        .link-button {
          margin-top: 16px;
        }

        .footnote {
          color: white;
        }
      }
    `;
  }};
`;

const FeatureCard = ({
  imgSrc,
  status,
  eyebrow,
  head,
  subhead,
  cta,
  footnote
}) => (
  <Style className="feature-card" imgSrc={imgSrc}>
    <div className="text-container">
      {status}
      {eyebrow && <Eyebrow text={eyebrow} />}
      {head}
      {subhead && <DescriptionText text={subhead} xl />}
      {footnote && <Footnote text={footnote} />}
      {cta?.text &&
        cta?.href && <LinkButton href={cta.href}>{cta.text}</LinkButton>}
    </div>
  </Style>
);

FeatureCard.defaultProps = {
  imgSrc: { mb: undefined, dt: undefined },
  status: null,
  eyebrow: undefined,
  head: undefined,
  subhead: undefined,
  cta: undefined,
  footnote: undefined
};

FeatureCard.propTypes = {
  imgSrc: PropTypes.shape({
    mb: PropTypes.string,
    dt: PropTypes.string
  }),
  status: PropTypes.node,
  eyebrow: PropTypes.node,
  head: PropTypes.node,
  subhead: PropTypes.node,
  cta: PropTypes.shape({
    text: PropTypes.string,
    href: PropTypes.string
  }),
  footnote: PropTypes.string
};

export default FeatureCard;
